import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const InvoiceHistorySearch: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [sender, setSender] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setSearch(params.get('search') || '');
        setSender(params.get('sender') || '');
        setDateFrom(params.get('dateFrom') || '');
        setDateTo(params.get('dateTo') || '');
    }, [location.search]);

    const submit = (event: React.FormEvent) => {
        event.preventDefault();
        const params = new URLSearchParams();

        if (search.trim()) params.set('search', search.trim());
        if (sender) params.set('sender', sender);
        if (dateFrom) params.set('dateFrom', dateFrom);
        if (dateTo) params.set('dateTo', dateTo);

        navigate(`/invoice-history${params.toString() ? `?${params.toString()}` : ''}`);
    };

    return (
        <form onSubmit={submit}>
            <div className="filter clear" style={{width: '99%'}}>
                <div className="content" style={{width: '100%'}}>
                    <p style={{display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                        <label>
                            <strong>Otsing:</strong>{' '}
                            <input
                                className="w200"
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                                placeholder="Arve nr, klient, saatja või põhjus"
                            />
                        </label>
                        <label>
                            <strong>Saatja:</strong>{' '}
                            <select value={sender} onChange={(event) => setSender(event.target.value)}>
                                <option value="">Kõik</option>
                                <option value="user">Kasutaja</option>
                                <option value="elog">Elog</option>
                            </select>
                        </label>
                        <label>
                            <strong>Periood:</strong>{' '}
                            <input type="date" value={dateFrom} onChange={(event) => setDateFrom(event.target.value)}/>
                            {' – '}
                            <input type="date" value={dateTo} onChange={(event) => setDateTo(event.target.value)}/>
                        </label>
                    </p>
                </div>
                <p className="action">
                    <button type="submit"><span><strong>Otsi</strong></span></button>{' '}
                    <button type="button" onClick={() => navigate('/invoice-history')}><span>Tühjenda</span></button>
                </p>
            </div>
        </form>
    );
};

export default InvoiceHistorySearch;
